import AbstractStore from "../../Common/Stores/AbstractStore";

export default class MarkerStore extends AbstractStore {
    constructor() {
        super(["load", "clear", "add"]);

        this.markers = [];
    }

    load(markers) {
        this.actions.load(markers);
    }

    clear() {
        this.actions.clear();
    }

    add(marker) {
        this.actions.add(marker);
    }

    onLoad(markers) {
        this.markers = markers;
        this.trigger(this.markers);
    }

    onAdd(marker) {
        this.markers.push(marker);
        this.trigger(this.markers);
    }

    onClear() {
        Object.values(this.markers).forEach((marker) => { marker.setMap(null); });
        this.markers = [];
        this.trigger(this.markers);
    }
}

export function createMarkerStore(initialState) {
    const store = new MarkerStore();
    store.load(initialState);

    return store;
}



// WEBPACK FOOTER //
// ./src-js/Fratello/Map/Stores/MarkerStore.jsx